module.exports = __webpack_public_path__ + "media/images/back-crowd@3x-45b25798.jpg";